// Frontend configuration
export const config = {
    apiUrl: import.meta.env.REACT_APP_API_URL || 'http://localhost:7071/api',
    blobStorageUrl: import.meta.env.REACT_APP_BLOB_STORAGE_URL || 'https://billsstorage984.blob.core.windows.net'
};
